export const WORK_DIRECTON_BASE_PATH = '/dt';
export const WORK_DIRECTON_APP = `${WORK_DIRECTON_BASE_PATH}/:orgId`;

const REPORT = 'report';
export const PATHS = {
  ATTENDANCE: 'attendance',
  DAILY: 'daily',
  HOLIDAYS: 'holidays',
  MODIFICATIONS: 'modifications',
  ACTIVE_ENTERPRISES: 'active_enterprises',
  INACTIVE_ENTERPRISES: 'inactive_enterprises',
  ISSUES: 'issues',
  HASH: 'hash',
};
export const MENU_PATHS = {
  PORTAL: `${WORK_DIRECTON_BASE_PATH}`,
  ATTENDANCE_REPORT: `${REPORT}/${PATHS.ATTENDANCE}`,
  DAILY: `${REPORT}/${PATHS.DAILY}`,
  HOLIDAYS: `${REPORT}/${PATHS.HOLIDAYS}`,
  MODIFICATIONS: `${REPORT}/${PATHS.MODIFICATIONS}`,
  ACTIVE_ENTERPRISES: `${REPORT}/${PATHS.ACTIVE_ENTERPRISES}`,
  INACTIVE_ENTERPRISES: `${REPORT}/${PATHS.INACTIVE_ENTERPRISES}`,
  ISSUES: `${REPORT}/${PATHS.ISSUES}`,
  HASH: `${REPORT}/${PATHS.HASH}`,
};

export const AUTH_DT_ROUTES = {
  SIGN_IN: `${WORK_DIRECTON_BASE_PATH}/signIn`,
  ENTER_PASSWORD: `${WORK_DIRECTON_BASE_PATH}/enter-password`,
};

export const DT_SESSION_CLOSED_KEY = 'dtSessionClosed';

export const DT_FORMS = {
  ATTENDANCE_REPORT: 'attendanceReport',
  WORKING_DAY_REPORT: 'workingDayReport',
  HOLIDAYS_REPORT: 'holidaysReport',
  MODIFICATIONS_REPORT: 'modificationsReport',
  INCIDENTS_REPORT: 'incidentsReport',
  HASH_REPORT: 'hashReport',
};

export const DT_PROCESS_TYPES = {
  INDIVIDUAL: 'individual',
  GROUP: 'group',
  HASH: 'hash',
  ISSUES: 'issues',
};

export const USERS_SELECTED_ALL = 'all';

export const DT_FORM_FIELDS = {
  PERIOD: 'period',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  USER_ID: 'userId',
  WORKING_DAY: 'workingDay',
  SHIFT: 'shift',
  REGION: 'region',
  PREMISES: 'premises',
  JOB: 'job',
  CONSTRACTOR: 'contractor',
  USERS_SELECTED: 'usersSelected',
  HASH: 'hash',
};

export const KIND_OF_REPORTS = {
  ATTENDANCE: 'attendance',
  DAILY: 'daily',
  HOLIDAYS: 'holidays',
  MODIFICATIONS: 'modifications',
  ACTIVE_ENTERPRISES: 'active_enterprises',
  INACTIVE_ENTERPRISES: 'inactive_enterprises',
  ISSUES: 'issues',
  HASH: 'hash',
};

export const ATTENDANCE_WORK_CIRCUMSTANCES = {
  DEPENDS_ON_TIME_BAND: 'timeTracker.attendance.workCircumstances.dependsOnTimeBand',
  INDEPENDENT_OF_TIME_BAND: 'timeTracker.attendance.workCircumstances.independentOfTimeBand',
};

export const SHIFT_CHANGES_REQUEST_BY = {
  EMPLOYEE: 'EMPLOYEE',
  SUPERVISOR: 'SUPERVISOR',
};

export const ATTENDANCE_TYPES = {
  SHIFT_CHANGES: 'SHIFT_CHANGES',
  SHIFT_START: 'SHIFT_START',
};

export const ATTENDANCE_WORK_CIRCUMSTANCES_VALUES = {
  DEPENDS_ON_TIME_BAND: 'DEPENDS_ON_TIME_BAND',
  INDEPENDENT_OF_TIME_BAND: 'INDEPENDENT_OF_TIME_BAND',
};
